import SectionHead from "./SectionHead";

const STEPS = [
  {
    date: "第 01 话",
    phase: "起因",
    title: "一份名单点燃火药桶",
    desc: "总决赛入围名单提前流出，两位种子选手的排位与观众预期落差极大，讨论区从当晚开始涌入大量质疑贴。",
    tag: "话题热度飙升",
  },
  {
    date: "第 02 话",
    phase: "起因",
    title: "正片预告出现穿帮",
    desc: "预告里一个 0.8 秒的画面与正式文案对不上，敏锐的网友顺着时间戳扒出了前后矛盾之处。",
    tag: "细节党狂欢",
  },
  {
    date: "第 03 话",
    phase: "经过",
    title: "两派支持者隔空对峙",
    desc: "观点分裂成两派：一派认为存在剪辑引导，一派认为只是过度解读，相关词条轮番登榜。",
    tag: "评论区刷屏",
  },
  {
    date: "第 04 话",
    phase: "经过",
    title: "制作组发出第一个声明",
    desc: "官方回应称个别镜头为“节奏需要”，并承诺补充说明。但声明反而让更多疑问浮出水面。",
    tag: "声明后再反转",
  },
  {
    date: "第 05 话",
    phase: "高潮",
    title: "加长花絮版全量放出",
    desc: "一段近两小时的未剪辑花絮曝光，关键决策过程首次完整呈现，此前所有矛盾瞬间有了不同答案。",
    tag: "单条播放破千万",
  },
  {
    date: "第 06 话",
    phase: "转折",
    title: "当事人直播正面回应",
    desc: "主角在直播里逐条解释决策逻辑，坦言镜头之外的真实感受，态度诚恳打动了不少此前持反对意见的观众。",
    tag: "口碑开始回温",
  },
  {
    date: "第 07 话",
    phase: "大结局",
    title: "官方致歉并重剪收官",
    desc: "制作组公开致歉，同步上线重剪版最终回，胜负与归属在更完整的信息下尘埃落定。",
    tag: "88大结局上线",
  },
  {
    date: "第 08 话",
    phase: "收尾",
    title: "片尾彩蛋埋下新伏笔",
    desc: "最后一帧闪过一句话与全新场景，暗示下一季正在路上，观众从“吵结局”转入了“猜新坑”。",
    tag: "收尾讨论进行中",
  },
];

const chipTone: Record<string, string> = {
  起因: "bg-secondary-100 text-secondary-900",
  经过: "bg-primary-100 text-primary-700",
  高潮: "bg-accent-500 text-background-50",
  转折: "bg-primary-100 text-primary-700",
  大结局: "bg-primary-500 text-background-50",
  收尾: "bg-accent-100 text-accent-800",
};

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-20 border-y border-background-200 bg-background-100/60 py-14 md:py-20">
      <div className="page-shell">
        <SectionHead
          kicker="事件时间线"
          title="从起因到收尾，一次看完 8 话"
          desc="按真实发生的先后顺序，把这次 88吃瓜 全程整理成时间线。每一条都可独立跳读，看完就等于补完了前因后果。"
        />

        <ol className="relative mt-12 ml-3 border-l-2 border-background-300 md:ml-5">
          {STEPS.map((step, i) => (
            <li key={i} className="relative pb-10 pl-7 last:pb-0 md:pl-9">
              <span
                className="absolute -left-[13px] top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-background-200 bg-background-50"
                aria-hidden="true"
              >
                <span className="h-2.5 w-2.5 rounded-full bg-accent-500" />
              </span>
              <div className="flex flex-wrap items-center gap-2">
                <span className={`chip px-3 py-1 text-xs font-bold ${chipTone[step.phase]}`}>{step.phase}</span>
                <span className="text-xs font-bold tracking-wide text-foreground-600">{step.date}</span>
              </div>
              <h3 className="mt-2 text-base font-black text-foreground-950 md:text-lg">{step.title}</h3>
              <p className="mt-1.5 max-w-3xl text-sm text-foreground-700">{step.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-accent-700">
                <i className="ri-fire-line" aria-hidden="true" />
                {step.tag}
              </span>
            </li>
          ))}
        </ol>

        <aside className="mt-12 flex flex-col gap-3 rounded-2xl border border-accent-200 bg-accent-100/60 p-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-accent-900">
            <strong>划重点：</strong>核心矛盾其实集中在第 05 话的加长花絮与第 07 话的重剪结局，想省时间可重点看这两处。
          </p>
          <a
            href="#finale"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
          >
            直达大结局复盘
            <i className="ri-arrow-down-line" aria-hidden="true" />
          </a>
        </aside>
      </div>
    </section>
  );
}